/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_IntroInputs */

const en_privacy_intro = /** @type {(inputs: Privacy_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep (bystep.dev) turns an idea or a codebase into a PRD, features and tasks, and hands those tasks to your AI coding agent. This policy explains what we collect, why, and what you can do about it.`)
};

const id_privacy_intro = /** @type {(inputs: Privacy_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep (bystep.dev) mengubah ide atau codebase menjadi PRD, fitur, dan task, lalu menyerahkan task itu ke agen AI coding milikmu. Kebijakan ini menjelaskan apa yang kami kumpulkan, untuk apa, dan apa yang bisa kamu lakukan.`)
};

/**
* | output |
* | --- |
* | "Bystep (bystep.dev) turns an idea or a codebase into a PRD, features and tasks, and hands those tasks to your AI coding agent. This policy explains what we c..." |
*
* @param {Privacy_IntroInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_intro = /** @type {((inputs?: Privacy_IntroInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_IntroInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_intro(inputs)
	return en_privacy_intro(inputs)
});